import { ReportColumnKind } from "@common/schemas/domains/accounting/report.schema";
import { ReportPeriodWithLabel } from "@common/types/reports/types";

/**
 * Column-kind predicates for consolidated P&L / Balance Sheet reports. A
 * consolidated report's periods are per-entity columns followed by an
 * Eliminations column and a post-elimination Consolidated Total. Non-consolidated
 * reports leave `columnKind` undefined, so these all return false for them.
 */

export function isEliminationsColumn(period: ReportPeriodWithLabel): boolean {
    return columnKindOf(period) === "eliminations";
}

export function isConsolidatedTotalColumn(
    period: ReportPeriodWithLabel,
): boolean {
    return columnKindOf(period) === "consolidated";
}

function columnKindOf(
    period: ReportPeriodWithLabel,
): ReportColumnKind | undefined {
    return period.columnKind;
}
